import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
/**
import CommonButtonBadge from '../components/CommonButtonBadge';
*/
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

class DataTableSupplyDataSupplyHr extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {}

    render() {

        let props = this.props;

        let { onSetEdit, onDropDownChange, onCheckDelete, onCheckDeleteAll, onPaginationChange } = props;

        let { Action, DataTable, Inputs, Deletes, Operation } = props;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
    
                <Row>
                    <Col md={12}>
                        {DataTable?.rows?.length > 0 ? 
                            <Table 
                                responsive 
                                borderless 
                                className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                            >
                                <thead>
                                    <tr>
                                        <th className="th-td-align-center th-width-50p"></th>
                                        <th className="th-width-auto"></th>
                                        {/**<th className="th-width-200p"></th>*/}
                                        <th className="th-width-50p"></th>
                                        <th className="th-td-align-center th-width-50p">
                                            {deleteChecked > 0 && (
                                                <Form.Check 
                                                    type="checkbox"
                                                    checked={Deletes.checkAll}
                                                    onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                                />
                                            )}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DataTable.rows.map((row, index) => {

                                        Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });
                                        
                                        rowId++;

                                        let del = true;

                                        return (
                                            <React.Fragment key={`${rowId}-${row.id}`}>
                                                <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                    <td className="th-td-align-center">
                                                        <CommonRowId rowId={rowId}/>
                                                    </td>
                                                    <td className="text-truncate" title={row.academy_name}>
                                                        {row.academy_name}

                                                        {(row.faculty_name || row.department_name || row.department_work_name) && (
                                                            <p className="title-xs mt-1 mb-0 d-flex flex-wrap align-items-center">
                                                                {row.faculty_name && (
                                                                <>
                                                                    <i className="fa-classic fa-light fa-layer-group fa-fw me-2"></i>
                                                                    คณะ <span className="me-2">{row.faculty_name}</span>
                                                                </>
                                                                )}

                                                                {row.department_name && (
                                                                <>
                                                                    <i className="fa-classic fa-light fa-timeline fa-fw me-2"></i>
                                                                    สาขาวิชา <span className="me-2">{row.department_name}</span>
                                                                </>
                                                                )}

                                                                {row.department_work_name && (
                                                                <>
                                                                    <i className="fa-classic fa-light fa-split fa-fw me-2"></i>
                                                                    สาขางาน <span className="me-2">{row.department_work_name}</span>
                                                                </>
                                                                )}
                                                            </p>
                                                        )}
                                                                                                            
                                                        {(row.education_rows > 0 || row.skills_set_rows > 0 || row.industries_rows > 0 ) && (
                                                              
                                                            <p className="title-xs mt-1 mb-0"> 
                                                                {row.education_rows > 0 && (
                                                                    <>
                                                                    <i className="fa-classic fa-light fa-graduation-cap fa-fw me-2"></i>นักศึกษา
                                                                    <Badge className="badge-sm ms-2 me-2" pill bg="dark">{util.formatNumber(row.education_rows, true)}</Badge>
                                                                    </>
                                                                )}
                                                                
                                                                {row.skills_set_rows > 0 && (
                                                                    <>
                                                                    <i className="fa-classic fa-light fa-star-shooting fa-fw me-2"></i>Skills Set
                                                                    <Badge className="badge-sm ms-2 me-2" pill bg="dark">{util.formatNumber(row.skills_set_rows, true)}</Badge>
                                                                    </>
                                                                )}

                                                                {row.industries_rows > 0 && (
                                                                    <>
                                                                    <i className="fa-classic fa-light fa-building-circle-check fa-fw me-2"></i>อุตสาหกรรม
                                                                    <Badge className="badge-sm ms-2 me-2" pill bg="dark">{util.formatNumber(row.industries_row, true)}</Badge>
                                                                    </>
                                                                )}                                                                
                                                            </p>
                                                        )}                                           
                                                    </td>
                                                    {/** 
                                                    <td>
                                                        <CommonDropdown
                                                            element="DataTable"
                                                            input={{id: 'operation', value: '0'}}
                                                            option={{source: 'options', section: 'operation', item: 'supply_human_resource'}}
                                                            callback={(e, element) => onDropDownChange('navigate', e, element, {key: 'supply_hr_id', value: row.id, label: row.academy_name})} 
                                                        />
                                                    </td>
                                                    */}
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="edit" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onSetEdit(e, {id: row.id})} 
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {del && (
                                                            <Form.Check 
                                                                type="checkbox"
                                                                name="deletes"
                                                                value={row.id}
                                                                checked={Deletes.deletes.includes(row.id)}
                                                                onChange={(e) => onCheckDelete(e)} 
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr className="table-row-gap"><td /></tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        :
                            <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                        }

                        {!Action.Loading.dataTable && (
                            <CommonPagination 
                                Pagination={DataTable.pagination} 

                                handlePagination={(paging) => onPaginationChange(paging)}
                            />
                        )}
                        
                    </Col>
                </Row>

            </Container>
        );
    }
}

export default DataTableSupplyDataSupplyHr;
